import { FilterOutlined } from "@ant-design/icons"
import { Badge, Button } from "antd"
import React from "react"

interface FilterDrawerTriggerProps {
  onClick: () => void
  activeCount: number
}

export function FilterDrawerTrigger({
  onClick,
  activeCount
}: FilterDrawerTriggerProps) {
  return (
    <Badge count={activeCount} size="small">
      <Button icon={<FilterOutlined />} onClick={onClick}>
        More Filters
      </Button>
    </Badge>
  )
}
